import React, { useContext, useEffect, useState } from 'react';
import './PlaceOrder.css';
import { StoreContext } from '../context/StoreContext';
import axios from "axios";
import PaymentMethod from '../PaymentMethod/PaymentMethod';
import { useNavigate } from "react-router-dom";

export default function PlaceOrder() {
    const { getTotalCartAmount, token, bev_list, cartItems, url } = useContext(StoreContext);
    const [showPayment, setShowPayment] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState(null);
    const [orderData, setOrderData] = useState(null);
    const navigate = useNavigate();

    const [data, setData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        street: "",
        city: "",
        brgy: "",
        zipcode: "",
        phone: ""
    });

    const onChangeHandler = (event) => {
        const { name, value } = event.target;
        setData(prevData => ({ ...prevData, [name]: value }));
    };

    const saveOrder = async (selectedPaymentMethod) => {
      const localDate = new Date().toISOString().split("T")[0];

      let orderItems = [];
      bev_list.forEach((item) => {
        if (cartItems[item._id] > 0) {
          let itemInfo = { ...item, quantity: cartItems[item._id] };
          orderItems.push(itemInfo);
        }
      });

      const orderData = {
        address: data,
        items: orderItems,
        amount: getTotalCartAmount() + 50,
        paymentMethod: selectedPaymentMethod,
        date: localDate,
        userId: token, // ⚠️ ensure you’re passing correct userId from token or context
      };

      try {
        const response = await axios.post(url + "/api/order/place", orderData, {
          headers: { token },
        });

        if (response.data.success) {
          if (selectedPaymentMethod === "Cash on Delivery") {
            navigate("/orders");
          } else if (selectedPaymentMethod === "E-Wallet") {
            window.location.href = response.data.session_url; // 🔑 Stripe Checkout
          }
        } else {
          alert("Error saving order");
        }
      } catch (error) {
        console.error(error);
        alert("Error placing order");
      }
    };

    useEffect(() => {
        if (!token) {
            navigate('/cart');
        } else if (getTotalCartAmount() === 0) {
            navigate('/cart');
        }
    }, [token, navigate, getTotalCartAmount]);

    return (
        <>
            <form className="place-order">
                <div className="place-order-left">
                    <p className="title">Delivery Information</p>
                    <div className="multi-fields">
                        <input required name='firstName' onChange={onChangeHandler} value={data.firstName} type="text" placeholder='First name' />
                        <input required name='lastName' onChange={onChangeHandler} value={data.lastName} type="text" placeholder='Last name' />
                    </div>
                    <input required name='email' onChange={onChangeHandler} value={data.email} type="email" placeholder='Enter e-mail address' />
                    <input required name='street' onChange={onChangeHandler} value={data.street} type="text" placeholder='Street' />
                    <div className="multi-fields">
                        <input required name='city' onChange={onChangeHandler} value={data.city} type="text" placeholder='City' />
                        <input required name='brgy' onChange={onChangeHandler} value={data.brgy} type="text" placeholder='Brgy' />
                    </div>
                    <div className="multi-fields">
                        <input required name='zipcode' onChange={onChangeHandler} value={data.zipcode} type="text" placeholder='Zip code' />
                        <input required name='phone' onChange={onChangeHandler} value={data.phone} type="text" placeholder='Phone' />
                    </div>
                </div>
                <div className="place-order-right">
                    <div className="cart-total">
                        <h2>Cart Totals</h2>
                        <div className="cart-total-details">
                            <p>Subtotal</p>
                            <p>P{getTotalCartAmount()}</p>
                        </div>
                        <hr />
                        <div className="cart-total-details">
                            <p>Delivery Fee</p>
                            <p>P{50}</p>
                        </div>
                        <hr />
                        <div className="cart-total-details">
                            <b>Total</b>
                            <b>P{getTotalCartAmount() + 50}</b>
                        </div>
                    </div>
                </div>
                <div className="place-order-center">
                    <div className="select-method">
                        <h2>Select Payment Method</h2>
                        <div className="payment-details">
                            <ul className="payment-method">
                                <button type='button' onClick={() => saveOrder('Cash on Delivery')}><p>Cash on Delivery</p></button>
                                <button type='button' onClick={() => saveOrder('E-Wallet')}><p>Place Order</p></button>
                            </ul>
                        </div>
                    </div>
                </div>
            </form>
            {showPayment && <PaymentMethod setShowPayment={setShowPayment} paymentMethod={paymentMethod} orderData={orderData} />}
        </>
    );
}
